import { figmaPxToWidthPercent, figmaPxToHeightPercent } from '@ui/Report';

/**
 * Target label beside summary chart — Figma node 4767:41123.
 * `*Percent` values are page-box fractions (use as `%`); the rest are scaling
 * numbers (feed to `getScalingSize` / `Report.Text`, which pick the unit).
 */
export const REPORT_SUMMARY_TARGET_LABEL = {
  /** Inset from page right edge — % of page width. */
  offsetRightPercent: figmaPxToWidthPercent(38),
  /** Vertical offset above the target line — % of page height. */
  offsetAboveLinePercent: figmaPxToHeightPercent(8),
  /** Font size — scaling number. */
  fontSize: figmaPxToWidthPercent(20),
  /** Cloud icon — ~50% larger than {@link fontSize} so the glyph matches the value optically. */
  iconSize: figmaPxToWidthPercent(30),
  /** Gap between label and value group — scaling number. */
  outerGap: figmaPxToWidthPercent(16),
  /** Gap between icon and value — scaling number. */
  innerGap: figmaPxToWidthPercent(4),
  fontFamily: '"Roboto", sans-serif',
  color: '#282a31',
} as const;

/**
 * Summary chart bar plot on the 1080px Figma page — max bar top at 408, feet at 911.
 * Positions are page-height fractions (`%`) on the report page.
 */
export const REPORT_SUMMARY_BAR_PLOT = {
  topPercent: figmaPxToHeightPercent(408),
  heightPercent: figmaPxToHeightPercent(503),
  feetPercent: figmaPxToHeightPercent(911),
} as const;

/**
 * Page-relative `bottom` for the summary target label aligned with the dashed
 * target line — Figma node 4767:41123. Returns a `%`-based calc (page-height
 * fractions), so it stays out of the container-query restyle path.
 *
 * @param targetLineBottomPercent Same ratio as the proposals target line within the bar plot.
 */
export const getReportSummaryTargetLabelBottomCss = (
  targetLineBottomPercent: number,
) => {
  const fromPageBottomPercent =
    100 -
    REPORT_SUMMARY_BAR_PLOT.feetPercent +
    REPORT_SUMMARY_BAR_PLOT.heightPercent * (targetLineBottomPercent / 100);
  return `calc(${fromPageBottomPercent}% + ${REPORT_SUMMARY_TARGET_LABEL.offsetAboveLinePercent}%)`;
};

/** Default summary page title when `Baseline.report_summary_title` is unset. */
export const REPORT_SUMMARY_DEFAULT_TITLE = 'Summary';
